import { MessageApi } from "@api/requests/MessageApi"
import { authApi } from "@api/requests/authApi"

const api = {
  MessageApi,
  authApi,
}

export default api
